import React from 'react';

const DirectionMain = () => {
  return (
    <main id="main" className='mt-10'>
      <div className="pb-5 main max-sm:pt-15 graybg main-bg">
 
        <div className="main max-sm:pt-15">
          <section className="p-0 about-section" id="category1">
            <div className="max-w-md mx-auto mb-5 overflow-hidden bg-white shadow rounded-xl md:max-w-6xl">
              <div className="flex flex-col items-center gap-6 md:flex-row md:items-start">
                <div className="w-full md:w-1/2" data-aos="fade-right">
                  <img alt="Description of image" className="w-full h-auto rounded-lg shadow" src="https://sunrisingcinevisionacademy.com/public/assets/images/director.jpg" />
                </div>
                <div className="w-full p-6 md:w-1/2" data-aos="fade-left">
                  <h2 className="mb-2 text-2xl font-bold">Become a Visionary Director with Sunrising Cinevision Academy</h2>
                  <p className="mb-4 text-gray-700">
                    The Direction Course at Sunrising Cinevision Academy is designed to equip aspiring filmmakers with the knowledge, techniques, and hands-on experience needed to bring compelling stories to life. This comprehensive course covers all aspects of film direction, from storytelling and script analysis to advanced directing techniques, industry partnerships, and marketing strategies. With expert guidance from renowned filmmakers and industry professionals, students will gain the skills and confidence to excel in the world of cinema.
                  </p>
                  <h2 className="mb-2 text-2xl font-bold">What You Will Learn</h2>
                  <ul className="pl-5 list-disc">
                    <li>Fundamentals of storytelling, narrative structure, and script analysis</li>
                    <li>Visual storytelling, camera techniques, lighting, and staging</li>
                    <li>Directing actors and managing on-set production</li>
                    <li>Editing, sound design, and post-production processes</li>
                    <li>Film production management, marketing, and distribution strategies</li>
                    <li>Specialized training in documentary filmmaking, music video direction, and more</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="max-w-md mx-auto mb-5 md:max-w-6xl">
              <div className="grid grid-cols-1 gap-5 mb-5 md:grid-cols-2">
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-right">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Foundational Courses:</h2>
                    <ul className="pl-5 list-decimal">
                      <li>Introduction to Film Direction</li>
                      <li>Storytelling and Narrative Structure</li>
                      <li>Visual Storytelling</li>
                      <li>Script Analysis and Development</li>
                      <li>Film History and Appreciation</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-left">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Intermediate Courses:</h2>
                    <ol className="pl-5 list-decimal">
                      <li>Directing Actors</li>
                      <li>Camera and Lighting Techniques</li>
                      <li>Blocking and Staging</li>
                      <li>Editing and Post-Production</li>
                      <li>Sound Design and Music Composition</li>
                    </ol>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-right">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Advanced Courses:</h2>
                    <ol className="pl-5 list-decimal">
                      <li>Advanced Directing Techniques</li>
                      <li>Film Genre Studies (Comedy, Drama, Thriller, etc.)</li>
                      <li>Visual Effects and CGI</li>
                      <li>Film Production Management</li>
                      <li>Film Marketing and Distribution</li>
                    </ol>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-left">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Specialized Courses:</h2>
                    <ol className="pl-5 list-decimal">
                      <li>Documentary Filmmaking</li>
                      <li>Short Film Making</li>
                      <li>Web Series Creation</li>
                      <li>Music Video Direction</li>
                      <li>Advertising and Commercial Direction</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <div className="max-w-md p-10 mx-auto mb-5 overflow-hidden bg-white shadow md:max-w-6xl rounded-xl">
              <h2 className="mb-10 text-4xl font-bold text-center" style={{ fontSize: '2.25rem' }}>Learn from the Best</h2>
              <div className="grid grid-cols-1 gap-5 mb-5 md:grid-cols-2">
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Celebrity Instructors:</h2>
                    <ul className="pl-5 list-disc">
                      <li>Rajkumar Hirani</li>
                      <li>Anurag Kashyap</li>
                      <li>Shoojit Sircar</li>
                      <li>Gauri Shinde</li>
                      <li>Imtiaz Ali</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Guest Lecturers:</h2>
                    <ul className="pl-5 list-disc">
                      <li>Karan Johar</li>
                      <li>Sanjay Leela Bhansali</li>
                      <li>Vidhu Vinod Chopra</li>
                      <li>Farhan Akhtar</li>
                      <li>Zoya Akhtar</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="max-w-md mx-auto mb-5 md:max-w-6xl">
              <div className="grid grid-cols-1 gap-5 mb-5 md:grid-cols-2">
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Industry Partnerships</h2>
                    <ul className="pl-5 list-disc">
                      <li>Yash Raj Films</li>
                      <li>Dharma Productions</li>
                      <li>Reliance Entertainment</li>
                      <li>Excel Entertainment</li>
                      <li>Sony Pictures Networks</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Alumni Network</h2>
                    <ul className="pl-5 list-disc">
                      <li>Connect with successful alumni in film, television, and theater.</li>
                      <li>Participate in mentorship programs.</li>
                      <li>Access job placement opportunities.</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Certifications Offered</h2>
                    <ul className="pl-5 list-disc">
                      <li>Diploma in Film Direction</li>
                      <li>Certificate in Film Direction</li>
                      <li>Advanced Certificate in Film Direction</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Scholarship Opportunities</h2>
                    <ul className="pl-5 list-disc">
                      <li>Merit-based scholarships</li>
                      <li>Need-based scholarships</li>
                      <li>Talent-based scholarships</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Course Duration</h2>
                    <ul className="pl-5 list-disc">
                      <li>Certification Course in Film Direction – 4 months</li>
                      <li>Certification Course in Film Direction – 6 months</li>
                      <li>Diploma Course in Film Direction – 12 months</li>
                    </ul>
                  </div>
                </div>
                <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                  <div className="p-8">
                    <h2 className="text-xl font-bold tracking-wide uppercase">Key Learning Outcomes</h2>
                    <ul className="pl-5 list-disc">
                      <li>Develop storytelling and visual storytelling skills.</li>
                      <li>Master script analysis, development, and direction.</li>
                      <li>Gain expertise in camera, lighting, and sound design.</li>
                      <li>Understand film production management and marketing.</li>
                      <li>Learn editing, post-production, and visual effects techniques.</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-span-1 overflow-hidden bg-white shadow rounded-xl aos-init aos-animate" data-aos="fade-up">
                <div className="p-8">
                  <h2 className="text-xl font-bold tracking-wide uppercase">Start Your Journey in Film Direction Today!</h2>
                  <p>Enroll in the Direction Course at Sunrising Cinevision Academy and take the first step toward becoming a successful filmmaker.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default DirectionMain;